<template>
  <div>
      <button 
        v-for="option in options"
        v-bind:key="option.id"
        class="toggle-button"
        v-bind:class="{ 'toggle-button-selected': selectedOption == option.id }"
        @click="selectOption(option)"
        >{{option.label}}</button>
  </div>
</template>
<style scoped>
.toggle-button {
    color: #474747;
    border: none;
    padding: 5px;
    padding-right: 10px;
    padding-left: 10px;
    margin-right: 10px;
    border-radius: 2px;
    margin-top: 10px;
}

.toggle-button-selected {
    background: #42c24e;
    color: white;
}

</style>

<script>

import qAPI from "../services/qAPI";

export default {
  props: ["options", "qlikApp"],
  data() {
    return {
        selectedOption: {}
    };
  },
  mounted() {
      if(this.options.length > 0) {
          this.selectOption(this.options[0])
      }
  },
  methods: {
    selectOption: function(option) {
        this.$emit('option-selected', option);
        this.selectedOption = option.id;
        if(this.qlikApp && option.selection) {
            this.qlikApp.field(option.selection.fieldName).selectValues(option.selection.fieldValues);
        }
    }
  }
}
</script>